import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Session } from '../../../../../../interfaces/session-data';
import { SessionService } from '../../../../../../services/session/session.service';

@Component({
  selector: 'app-pay-just-now',
  templateUrl: './pay-just-now.component.html',
  styleUrls: ['./pay-just-now.component.scss']
})
export class PayJustNowComponent implements OnInit {
  public link:string;
  private lock: boolean = false;
  private session:Session;
  constructor(
    private router:Router,
    private sessionService:SessionService,
    private route: ActivatedRoute
  ) {
    this.link = "pay-just-now";
  }

  ngOnInit(): void {
    this.session = sessionStorage.getItem("sessionData")? JSON.parse(sessionStorage.getItem("sessionData")) : null;
    this.selectMethod();
    this.sessionService.getPaymentMethodListLock().subscribe((lock:boolean) => {
      this.lock = lock;
    });
  }

  toggleListView(){
    this.sessionService.emitPaymentMethodPromotion("pay-just-now");
  }

  selectMethod(event?: Event){
    sessionStorage.setItem("selected-payment","pay-just-now");
    if(event!=undefined&&!this.lock){
      this.sessionService.setSelectedChargeAmount({
        currency:this.session.sessionDisplayInformation.currencyCode,
        amount:this.session.sessionDisplayInformation.amount
      });
      this.sessionService.setCurrencyCodeListLock(true);
      this.sessionService.emitSelectedPaymentMethod("pay-just-now");
      this.router.navigate([this.link],{relativeTo: this.route});
    }
  }

}
